// ── SKILL LOADER ─────────────────────────────────────────────────
// Loads skills from SKILL.md files at runtime via fetch().
// Single source of truth: the .md files themselves.

const LOADED_SKILLS = {};

const SKILL_NAMES = ['design-system', 'interaction-design'];

// Strip YAML frontmatter (--- ... ---) from markdown content
const stripFrontmatter = md => md.replace(/^---[\s\S]*?---\s*/, '');

// Load all skills in parallel on page init. Non-blocking — skills
// are available by the time the user finishes onboarding and triggers a build.
export const skillsReady = Promise.all(
  SKILL_NAMES.map(async name => {
    try {
      const res = await fetch(`skills/${name}/SKILL.md`);
      if (res.ok) {
        LOADED_SKILLS[name] = stripFrontmatter(await res.text()).trim();
      } else {
        console.warn(`Skill "${name}" returned ${res.status}`);
        LOADED_SKILLS[name] = '';
      }
    } catch (e) {
      console.warn(`Skill "${name}" failed to load:`, e);
      LOADED_SKILLS[name] = '';
    }
  }),
);

// ── Phase & section-type mapping ─────────────────────────────────
// Design philosophy IS injected into sections because the first 1-2 sections
// (header, hero) have NO referenceHtml and need creative direction beyond
// abstract mood keywords. Later sections get consistency via referenceHtml chain.
const PHASE_SKILLS = {
  section: ['design-system', 'interaction-design'],
};

// Which skills to inject per section type (additive to phase skills)
const SECTION_TYPE_SKILLS = {
  header: ['interaction-design'],
  hero: ['interaction-design'],
  features: ['interaction-design'],
  stats: ['interaction-design'],
  testimonials: ['interaction-design'],
};

export function getSkillsForPhase(phase) {
  return (PHASE_SKILLS[phase] || [])
    .map(n => LOADED_SKILLS[n])
    .filter(Boolean)
    .join('\n\n');
}

export function getSkillsForSection(sectionType) {
  const phaseSkills = PHASE_SKILLS.section || [];
  const typeSkills = SECTION_TYPE_SKILLS[sectionType] || [];
  const names = [...new Set([...phaseSkills, ...typeSkills])];
  return names
    .map(n => LOADED_SKILLS[n])
    .filter(Boolean)
    .join('\n\n');
}
